module.exports = {
	"apiUrl": "/api/v1",
	"apiServicesUrl": "/s/v1",
	"apiCrmAnalyticsUrl": "https://crmproduction.unigine.com/analytics/api",
	"apiIdUrl": "https://idproduction.unigine.com/api/v1",
	"siteFpUrl": "https://fpproduction.unigine.com",
	"apiFpUrl": "https://fpproduction.unigine.com/api/v1",
	"siteUnigineUrl": "https://unigineproduction.unigine.com",
	"env": "production"
};


//////////////////
// WEBPACK FOOTER
// ./src/config/common.json
// module id = 107
// module chunks = 0